import gsap from 'gsap';

export const openNav = () => {
    const tl = gsap.timeline({
        onStart: () => {
            document.body.classList.add('u-overflow-hidden');
        }
    });
    tl.addLabel('showParent');
    tl.to('.c-nav', { x: '0%', duration: 0.4 });
}

export const closeNav = () => {
    const tl = gsap.timeline({
        onStart: () => {
            document.body.classList.remove('u-overflow-hidden');
        },       
    });
    tl.to('.c-nav', { x: '100%', duration: 0.4 });
}